<template>
    <div
        class="grid grid-cols-1 lg:grid-cols-2 mx-auto md:min-h-[430px]"
        :class="rightSlot?.type == 'image' ? 'flex-col-reverse' : ''"
    >
        <div
            :class="{
                'overflow-hidden flex items-center justify-center order-1 lg:order-2': (leftSlot?.type == 'image' || leftSlot?.type == 'video'),
                'xl:py-12' : leftSlot?.type == 'video',
                '-mx-4 lg:mx-0' : leftSlot?.type == 'image',
                'py-6 xl:py-12 md:pe-6 lg:pe-12 order-2 lg:order-1': leftSlot?.type == 'text',
                'py-6 xl:py-12 md:pe-6 lg:pe-12 order-2 lg:order-1 text-card-left': leftSlot?.type == 'text-card'
            }"
        >
            <component :is="leftComponent" :content="leftSlot" />
        </div>

        <div
            :class="{
                'overflow-hidden flex items-center justify-center order-1 lg:order-2': (rightSlot?.type == 'image' || rightSlot?.type == 'video') ,
                'xl:py-12' : rightSlot?.type == 'video',
                '-mx-4 lg:mx-0' : rightSlot?.type == 'image',
                'py-6 xl:py-12 md:ps-6 lg:ps-12 order-2 lg:order-2': rightSlot?.type== 'text',
                'py-6 xl:py-12 md:ps-6 lg:ps-12 order-2 lg:order-2 text-card-right': rightSlot?.type == 'text-card'
            }"
        >
            <component :is="rightComponent" :content="rightSlot" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { HblSlot } from '@/utils/types'
import { hblToUpperCamelCase } from '@/utils/helper'

const props = defineProps<{
    content: HblSlot[]
}>()

const leftSlot = computed(() => {
    return props.content.find(item => item.position === 'left')
})

const rightSlot = computed(() => {
    return props.content.find(item => item.position === 'right')
})

const leftComponent = computed(() => {
    if (!leftSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(leftSlot.value.type)}`
})

const rightComponent = computed(() => {
    if (!rightSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(rightSlot.value.type)}`
})
</script>
